import { useMap } from 'es-map-widget';
import { MultiPolygon, Polygon } from 'ol/geom';
import { getVectorContext } from 'ol/render';
import { Fill, Style } from 'ol/style';
import { useEffect, useMemo } from 'react';
import { MAP_LAYER_NAMES } from '../../constants/mapLayerNames';
import { useWmsDates } from '../mapcontroller/contexts/WmsDateProvider';

const MASKED_LAYER_NAMES = [
    MAP_LAYER_NAMES.NDVI,
    MAP_LAYER_NAMES.CHANGE_MAP,
    MAP_LAYER_NAMES.DAMAGE_MAP,
];

const MASK_STYLE = new Style({
    fill: new Fill({ color: 'rgba(0, 0, 0, 0)' }),
});

const createMaskGeometry = (geom) => {
    if (geom?.type === 'Polygon' && Array.isArray(geom.coordinates)) {
        return new Polygon(geom.coordinates);
    }
    if (geom?.type === 'MultiPolygon' && Array.isArray(geom.coordinates)) {
        return new MultiPolygon(geom.coordinates);
    }
    return null;
};

const WmsMeparMask = () => {
    const map = useMap();
    const { wmsData } = useWmsDates();
    const maskGeometry = useMemo(() => createMaskGeometry(wmsData.meparGeom), [wmsData.meparGeom]);

    useEffect(() => {
        if (!map.map || !maskGeometry) {
            return undefined;
        }

        const maskedLayers = map.map
            .getAllLayers()
            .filter((layer) => MASKED_LAYER_NAMES.includes(layer.get('name')));

        const handlePreRender = (event) => {
            if (!(event.context instanceof CanvasRenderingContext2D)) {
                return;
            }

            event.context.save();
            const vectorContext = getVectorContext(event);
            vectorContext.setStyle(MASK_STYLE);
            vectorContext.drawGeometry(maskGeometry);
            event.context.clip();
        };

        const handlePostRender = (event) => {
            if (event.context instanceof CanvasRenderingContext2D) {
                event.context.restore();
            }
        };

        maskedLayers.forEach((layer) => {
            layer.on('prerender', handlePreRender);
            layer.on('postrender', handlePostRender);
            layer.changed();
        });

        return () => {
            maskedLayers.forEach((layer) => {
                layer.un('prerender', handlePreRender);
                layer.un('postrender', handlePostRender);
                layer.changed();
            });
        };
    }, [map, maskGeometry]);

    return null;
};

export default WmsMeparMask;
